// extracted by mini-css-extract-plugin
export default {"wrapper":"EditPolicyGeneralForm_wrapper__LOXIH","submitWrapper":"EditPolicyGeneralForm_submitWrapper__CUKf5"};